import { useQuery } from '@apollo/client';
import { GET_ADMIN_TODAY_PUZZLE } from '../graphql/Queries';

export interface HintBreakdown {
  zeroPct: number | null;
  onePct: number | null;
  twoPct: number | null;
  threePct: number | null;
}

export interface TodayPuzzleModeSnapshot {
  date: string;
  starts: number;
  wins: number;
  completionRate: number | null;
  medianElapsedTimeMs: number | null;
  numSolutions: number | null;
  hintBreakdown: HintBreakdown;
}

interface AdminTodayPuzzleData {
  adminTodayPuzzle: {
    success: boolean;
    errors?: string[];
    classic: TodayPuzzleModeSnapshot[];
    casual: TodayPuzzleModeSnapshot[];
  };
}

export function useAdminTodayPuzzle() {
  return useQuery<AdminTodayPuzzleData>(GET_ADMIN_TODAY_PUZZLE);
}
